import React from 'react';
import { motion } from 'framer-motion';
import { ChevronRightIcon } from 'lucide-react';
interface CTAButtonProps {
  text?: string;
  href?: string;
  onClick?: () => void;
  className?: string;
  subtext?: string;
}
export function CTAButton({
  text = 'SÍ, QUIERO EL MÉTODO CALMA® AHORA',
  href = 'https://checkout.descargatop.com/cart/40923243511857:1',
  onClick,
  className = '',
  subtext
}: CTAButtonProps) {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (onClick) {
      e.preventDefault();
      onClick();
    }
  };
  return <div className={`flex flex-col items-center w-full max-w-2xl mx-auto ${className}`} data-id="element-38">
      <motion.a href={href} onClick={handleClick} className="relative w-full group block" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} data-id="element-39">
        {/* Pulsing background glow */}
        <motion.div className="absolute -inset-1 bg-green-500 rounded-xl blur opacity-30 group-hover:opacity-60 transition duration-200" animate={{
        scale: [1, 1.05, 1],
        opacity: [0.3, 0.5, 0.3]
      }} transition={{
        duration: 2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-40" />

        {/* Main button */}
        <div className="relative w-full bg-gradient-to-b from-green-400 to-green-600 text-white font-black text-xl md:text-2xl lg:text-3xl py-5 px-4 rounded-xl shadow-[0_8px_0_rgb(21,128,61)] group-hover:shadow-[0_4px_0_rgb(21,128,61)] group-hover:translate-y-1 transition-all flex items-center justify-center text-center border-2 border-green-300" data-id="element-41">
          <span className="drop-shadow-md" data-id="element-42">{text}</span>
          <ChevronRightIcon className="w-8 h-8 ml-2 hidden md:block drop-shadow-md" data-id="element-43" />
        </div>
      </motion.a>

      {subtext && <p className="mt-4 text-sm md:text-base text-gray-500 font-medium text-center" data-id="element-44">
          {subtext}
        </p>}
    </div>;
}